"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IARef = void 0;
class IARef {
    get montiert() {
        return this.model.Montiert;
    }
    set montiert(value) {
        this.model.Montiert = value;
    }
    get id() {
        return this.model.Id;
    }
    set id(value) {
        this.model.Id = value;
    }
    get artNr() {
        return this.model.ArtNr;
    }
    constructor(model) {
        this.model = model;
    }
}
exports.IARef = IARef;
//# sourceMappingURL=IARef.js.map